import React from 'react';
import TkLinks from './TkLinks';

export const DesignerWebsiteLink = (props) => (
  <div className='hide-in-mobile'>
    <TkLinks {...props} /> for more information.
  </div>
)